import {computed, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import errorToast from "../../components/toast/ErrorToast";
import DateAdapter from "../../adapters/DateAdapter";
import {ORDER_PATH} from "../../routes";
import successToast from "../../components/toast/SuccessToast";

export default class ListPurchaseOrderFeature {

    constructor(application, navigator) {
        this._application = application;
        this._navigate = navigator;
        this._loaded = false;
        this._purchaseOrdersValidationResults = [];

        makeObservable(this, {
            _loaded: observable,
            _purchaseOrdersValidationResults: observable,
            loaded: computed,
            purchaseOrdersValidationResults: computed
        })
    }

    async load() {
        await this._getPurchaseOrdersValidationResults()
        this.finishLoading()
    }

    finishLoading() {
        this._loaded = true
    }

    get loaded() {
        return this._loaded;
    }

    set loaded(value) {
        this._loaded = value;
    }

    get purchaseOrdersValidationResults() {
        return this._purchaseOrdersValidationResults;
    }

    set purchaseOrdersValidationResults(value) {
        this._purchaseOrdersValidationResults = value;
    }

    columnsContent() {
        return [
            {id: 'purchaseOrderNumber', label: 'Órden de Compra'},
            {id: 'purchaseOrderEmissionDate', label: 'Fecha de emisión'},
            {id: 'clientBusinessName', label: 'Razón Social'},
            {id: 'deliverySiteName', label: 'Punto de entrega'},
            {id: 'customersEDICodeValidationResult', label: 'GLN Cliente'},
            {id: 'deliverySitesEDICodeValidationResult', label: 'GLN Punto de Entrega'},
            {id: 'customersArticlesEDICodeValidationResult', label: 'EAN Artículos'},
            {id: 'availableDeliveryDateValidationResult', label: 'Fecha de Entrega'},
            {id: 'articlePricesValidationResult', label: 'Precios'},
            {id: 'allArticleEansEnabledValidationResult', label: 'EAN Habilitados'},
            {id: 'orderUrl', label: 'Pedido'},
        ];
    }

    presentedPurchaseOrders() {
        let sortedPurchaseOrderValidationResults = this.purchaseOrdersValidationResults.slice().sort((result, anotherResult) => anotherResult.purchaseOrderEmissionDate - result.purchaseOrderEmissionDate)
        return sortedPurchaseOrderValidationResults.map(purchaseOrderValidationResult => {
            return this._presentedPurchaseOrder(purchaseOrderValidationResult);
        });
    }

    _presentedPurchaseOrder(purchaseOrderValidationResult) {
        const dateAdapter = new DateAdapter()
        return {
            id: purchaseOrderValidationResult.purchaseOrderNumber,
            purchaseOrderNumber: purchaseOrderValidationResult.purchaseOrderNumber,
            purchaseOrderEmissionDate: dateAdapter.adapt(purchaseOrderValidationResult.purchaseOrderEmissionDate),
            clientBusinessName: purchaseOrderValidationResult.clientBusinessName,
            deliverySiteName: purchaseOrderValidationResult.deliverySiteName,
            customersEDICodeValidationResult: purchaseOrderValidationResult.customersEDICodeValidationResult,
            deliverySitesEDICodeValidationResult: purchaseOrderValidationResult.deliverySitesEDICodeValidationResult,
            customersArticlesEDICodeValidationResult: purchaseOrderValidationResult.customersArticlesEDICodeValidationResult,
            availableDeliveryDateValidationResult: purchaseOrderValidationResult.availableDeliveryDateValidationResult,
            articlePricesValidationResult: purchaseOrderValidationResult.articlePricesValidationResult,
            allArticleEansEnabledValidationResult: purchaseOrderValidationResult.allArticleEansEnabledValidationResult,
            orderUrl: {
                urlName: purchaseOrderValidationResult.orderNumber,
                url: this.getOrderUrl(purchaseOrderValidationResult)
            },
        }
    }

    getOrderUrl(purchaseOrderValidationResult) {
        return ORDER_PATH + `/${purchaseOrderValidationResult.orderNumber}`;
    }

    async _getPurchaseOrdersValidationResults() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this.purchaseOrdersValidationResults = response.purchaseOrdersValidationResults();
            },
            handlesError: (response) => {
                errorToast('No se pudieron obtener las órdenes de compra')
            }
        });
        return this._application.apiClient().getPurchaseOrdersValidationResults(responseHandler)
    }

    async retryPurchaseOrdersValidationProcess() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this.load();
                successToast('Se han reprocesado las órdenes de compra fallidas')
            },
            handlesError: (response) => {
                errorToast('No se pudo ejecutar el proceso de validación de las órdenes de compra')
            }
        });
        this.loaded = false
        return this._application.apiClient().retryPurchaseOrdersValidationProcess(responseHandler)
    }
}